// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__KF4cE","alert":"SettungsInbox_alert__3pu2F"};